import React, { Component } from 'react';
import fire from '../../Firebase.js';

class SingleProud extends Component {
    addProudHandler(e){
        e.preventDefault();
        //const tutorName = fire.auth().currentUser.Name + ' ' + fire.auth().currentUser.Surname;
        const currentDate = new Date().getTime();
        console.log(currentDate);
          fire.database().ref('pride/imProudOf/').push({
            content: this.rContent.value,
            date: currentDate,
            name: this.userName.value,
            instagram: this.userInstagram.value,
            email: this.userEmail.value
          });
        }
    render(){
        return (
            <form onSubmit={this.addProudHandler.bind(this)}>
                <input type="text" className="form-control" placeholder="Your name" ref={ el => this.userName = el }/>
                <input type="email" className="form-control" placeholder="E-mail (not shown publicly)" ref={ el => this.userEmail = el }/>
                <input type="text" className="form-control" placeholder="Instagram @username (optional)" ref={ el => this.userInstagram = el }/>
                <textarea className="form-control" className="form-control" placeholder="I am proud of..." ref={ el => this.rContent = el } />
                <button className="btn baton">I am proud!</button>
            </form>
        )
    }
}

export default SingleProud;



// WEBPACK FOOTER //
// ./src/MainContainer/AddProudOf/AddProudOf.js